import { render } from "./MyDriveFiles.vue?vue&type=template&id=7b803940&ts=true"
import script from "./MyDriveFiles.vue?vue&type=script&lang=ts"
export * from "./MyDriveFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__